<template>
  <div class="createSuccess">
    <div class="main">
      <div class="success">
        <img class="icon" :src="item[state].src" />
        <p class="msg">{{item[state].name}}</p>
        <p class="msg2">{{item[state].desc}}</p>

        <div class="tip-header">说明</div>
        <div class="tip">1、参保人须为商户经营者或法定代表人，和营业执照保持一致；</div>
        <div class="tip">2、提交的商户信息均需为有效信息；</div>
      </div>

      <div class="btn" v-if="state==1" @click="edit()">修改参保信息</div>
      <div class="btn" v-if="state==2" @click="toindex()">查看我的保单</div>

    </div>
  </div>
</template>

<script>
export default {
  name: "newcreateSuccess",

  created() {
    this.state = parseInt(this.$route.query.state) || 0
  },
  data() {
    return {
      state:  0,
      item: [
        {
          name: "参保审核中…",
          src: require("../assets/waiting.png"),
          tip: [
            {
              title:
                "1、参保人须为商户经营者或法定代表人，和营业执照保持一致；",
            },
            { title: "2、提交的商户信息均需为有效信息；" },
          ],
        },
        {
          name: "审核拒绝",
          src: require("../assets/refause.png"),
          tip: [
            {
              title:
                "1、参保人须为商户经营者或法定代表人，和营业执照保持一致；",
            },
            { title: "2、提交的商户信息均需为有效信息；" },
          ],
        },
        {
          name: "参保成功",
          desc: "WiFi安全险保障中",
          src: require("../images/index/chenggong.png"),
        },
      ],
    };
  },
  mounted: function () {
    if (WiFikey && WiFikey.startComponent) {
      WiFikey.startComponent(
        JSON.stringify({
          aciton: "wifi.intent.action.WIFI_INSURANCE_ACTIVATED",
          type: 2,
          ext: "1",
        })
      );
    }
  },
  methods: {
    edit() {
      this.$router.push("/new/createStore?from=edit");
    },
    toindex() {
      this.$router.push("/new/insureDetail");
    },
  },
};
</script>

<style scoped>
.main {
  margin-top: 15px;
  text-align: center;
}
.logo {
  width: 60%;
}
.main .success {
  position: fixed;
  width: 100%;
  top: 20%;
}
.main .success .icon {
  width: 53.86667%;
  margin: 0 auto;
}
.main .msg {
  text-align: center;
  width: 100%;
  padding: 0;
  font-size: 20px;
  color: #0285f0;
  line-height: 26px;
  margin-top: 33px;
}
.main .msg2 {
  text-align: center;
  width: 100%;
  padding: 0;
  font-size: 14px;
  color: #000;
  line-height: 26px;
  font-weight: 300;
}
.main a {
  text-decoration: none;
  font-size: 13px;
  margin-top: 16px;
}
.btn {
  position: fixed;
  left: 50%;
  bottom: 5%;
  height: 42px;
  width: 70.6667%;
  transform: translateX(-50%);
  text-decoration: none;
  font-size: 16px;
  line-height: 42px;
  text-align: center;
  margin: 0 auto;
  -webkit-border-radius: 23px;
  -moz-border-radius: 23px;
  border-radius: 23px;
  color: #ffffff;
  background: #0285f0;
}
.tip-header {
  font-family: PingFangSC-Medium;
  font-size: 15px;
  color: #333333;
  letter-spacing: 0;
  line-height: 20px;
  margin: 25px 28px 14px;
  text-align: left;
}
.tip {
  text-align: left;
  font-size: 13px;
  color: #5c5c5c;
  letter-spacing: 0;
  line-height: 25px;
  padding: 0 28px;
}
</style>



// WEBPACK FOOTER //
// createSuccess.vue?5c5290de